import React, { FC, PropsWithChildren } from 'react';
import { useTheme } from 'styled-components';
import * as S from './ComplaintModal.styles';
import { useResponsive } from '@/hooks/useResponsive';
import { Modal } from '@/components/UI/Modal';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';
import { CloseIcon } from '@/components/UI/Icons/Icons';
import { Button } from '@/components/UI/Button/Button';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
}

export const ComplaintModal: FC<PropsWithChildren<Props>> = ({
  isOpen,
  onClose,
  title,
  children,
}) => {
  const { isDesktop } = useResponsive();
  const theme = useTheme();

  if (isDesktop)
    return (
      <Modal isOpen={isOpen} onClose={onClose} maxWidth={600}>
        <S.ModalContent>
          {title && (
            <S.ModalHeader>
              <S.ModalTitle>{title}</S.ModalTitle>
              <Button
                appearance="transparent"
                hasPadding={false}
                onClick={onClose}
              >
                <CloseIcon
                  width={15}
                  height={15}
                  fill={theme.palette.secondary.labels}
                />
              </Button>
            </S.ModalHeader>
          )}
          {children}
        </S.ModalContent>
      </Modal>
    );
  return (
    <BottomSheet
      isOpen={isOpen}
      close={onClose}
      title={title}
      isTitleCentered={false}
      hasHeadBorder={false}
    >
      {children}
    </BottomSheet>
  );
};
